import { get, isEmpty } from "lodash";

const getters = {
  customer: (state) => state.customer,
  piiAuthorized: (state) => state.pii_authorized,
  accountVerified: (state) => Boolean(state.account_verified),
  aridEnabled: (state) => state.arid_enabled,
  piiOn: (state) => state.pii_flag_on,
  piiOff: (state) => !state.pii_flag_on,
  dccsOn: (state) => state.dccs_flag_on,
  dccsOff: (state) => !state.dccs_flag_on,
  locations: (state) => {
    if (isEmpty(state.locations)) {
      return [];
    }

    return state.locations.map((location) => location);
  },
  email: (state) => get(state, "customer.email", "email_not_found"),
  phone_number: (state) =>
    get(state, "customer.phone_number", "phone_number_not_found"),
  tfa_phone_number: (state) =>
    get(state, "customer.tfa_phone_number", "tfa_phone_number_not_found"),
  allow_sms: (state) => get(state, "customer.allowSMS", "allow_sms_not_found"),
  rbacEnabled: (state) =>
    get(state, "customer.rbacEnabled", "rbac_enabled_not_found"),
  legalCountry: (state) =>
    get(state, "customer.metadata.country_name", null) || "N/A",
  customerId: (state) =>
    String(get(state, "customer.id", "customer_id_not_found")),
  currentDevice: (state) => state.currentDevice,
  isLocked: (state) => String(get(state, "customer.security_status")) === "1",
  channels(state) {
    return get(state, "customer.tfa_phone_number", "").length > 8
      ? ["SMS", "Email"]
      : ["Email"];
  },
  isAmazonLinkedAccount: (state) =>
    Boolean(state.customer["amazon_profile"] && state.dccs_flag_on),
  verificationChannels: (state) => state.verificationChannels,
  isFirstVerificationAttempt: (state) => state.isFirstVerificationAttempt,
};

export default getters;
